import API from "../../api/api";

const state = () => ({
  contacts: [],
  loading: false,
});

const mutations = {
  getContacts(state, payload) {
    state.contacts = payload;
  },
  isLoading(state, payload) {
    state.loading = payload;
  },
};

const actions = {
  async fetchContacts({ commit }) {
    await API.get("contact-us")
      .then(res => {
        commit("getContacts", res.data.data);
      })
      .catch(err => {
        console.log("ERROR", err);
      });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
